import React from 'react'
import Provider from 'react-redux/es/components/Provider'
import {Router} from 'react-router'
import {ThemeProvider} from '@material-ui/styles'
import routing from './shared/routing'

export default function Root({store, history, theme}) {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router history={history}>{routing(store)}</Router>
      </ThemeProvider>
    </Provider>
  )
}
